export default function pressboard() {
  const s = document.createElement('script');
  s.type = 'text/javascript';
  s.async = !0;
  s.src = 'https://adserver.pressboard.ca/v3/embedder?media=134218';
  const d = document.getElementsByTagName('script')[0];
  d.parentNode.insertBefore(s, d);
}
